import { useMemo } from 'react';
import type { RouterConfig } from '../Router';
import { useMobileRouter } from './useMobileRouter';
import { useWebRouter } from './useWebRouter';

export const usePlatformRouter = ({ isMobileRouter, onContinueInBrowser, platform }: RouterConfig) => {
  // TODO: This is hack
  const mobileRouter = useMobileRouter({ onContinueInBrowser, platform: platform === 'web' ? 'ios' : platform });
  const webRouter = useWebRouter();

  return useMemo(() => {
    if (isMobileRouter && platform !== 'web') {
      return [mobileRouter];
    }

    return webRouter;
  }, [isMobileRouter, platform, mobileRouter, webRouter]);
};
